import { useCallback, useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { useBlocker } from './useBlocker'
import axios from '../lib/axios'

export function useDeleteFramework(when: boolean): (boolean | (() => void))[] {
  const navigate = useNavigate()
  const location = useLocation()
  const [lastLocation, setLastLocation] = useState<any>(null)
  const [confirmedNavigation, setConfirmedNavigation] = useState(false)

  // Use a ref so the blocker always reads the latest value synchronously,
  // avoiding the timing gap between render and useEffect that could cause
  // the blocker to fire after save (when `when` is already false).
  const shouldDeleteRef = useRef(when)
  shouldDeleteRef.current = when

  const handleBlockedNavigation = useCallback(
    (nextLocation: any) => {
      if (shouldDeleteRef.current && nextLocation.location.pathname !== location.pathname) {
        setLastLocation(nextLocation)

        axios.delete('/api/v3/frameworks/custom').catch((e) => e)
        shouldDeleteRef.current = false
        setConfirmedNavigation(true)

        return false
      }
      return false
    },
    [location]
  )

  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      navigate(lastLocation.location?.pathname)

      setConfirmedNavigation(false)
    }
  }, [confirmedNavigation, lastLocation])

  useBlocker(handleBlockedNavigation, when)

  return [
    shouldDeleteRef.current,
    () => {
      shouldDeleteRef.current = false
    }
  ]
}
